export const PAGE_TYPE_INFORMATION = 'information';
export const PAGE_TYPE_SHOP = 'shop';
export const DEFAULT_PAGE_TYPE = PAGE_TYPE_INFORMATION;

export const SUPPORTED_PAGE_TYPES = [
  PAGE_TYPE_INFORMATION,
  PAGE_TYPE_SHOP,
] as const;

export type PageType = typeof SUPPORTED_PAGE_TYPES[number];

export function isSupportedPageType(value: string): value is PageType {
  return SUPPORTED_PAGE_TYPES.includes(value as PageType);
}
